import "../style/ContactFormStyles.css"

function ContactForm(){    return(
        <div className="form-container">
            <h1>Send us a message</h1>
            <form 
                action="https://getform.io/f/bolmxdla"
                method="POST"
                className="contact-form"
            >
                <input type="hidden" name="form-name" value="contact-form" />
                <input 
                    type="text" 
                    name="name" 
                    placeholder="Name" 
                    required 
                />
                <input 
                    type="email" 
                    name="email" 
                    placeholder="Email" 
                    required 
                />
                <input 
                    type="text" 
                    name="subject" 
                    placeholder="Subject" 
                    required 
                />
                <textarea 
                    name="message" 
                    placeholder="Message" 
                    rows="4" 
                    required
                ></textarea>
                <button type="submit">Send Message</button>
            </form>
        </div>
    )
}

export default ContactForm;